export default __webpack_public_path__ + "c61d33fa183bd7e6cff6b1f3143cee0a.jpg";